import { Outlet, useNavigate } from "react-router-dom";
import { DesktopNav, MobileNav } from "./navigations";
import { MobileView, BrowserView } from "react-device-detect";
import { useEffect } from "react";
import { appLinks } from "../../helpers/config";
import { isAuthenticated } from "../../helpers/auth";
import { isMemberAuthed } from "../../helpers/memberAuth";
import extAuth from "../../helpers/extAuth";
import { CopyRightTag } from ".";
import logo from "../../static/img/logo.png";
import { PageTitle } from "./page-title";
import { MemberLoginPage } from "../../pages/member/auth";

const AppLayout = (props) => {
  const nav = useNavigate();
  useEffect(() => {
    if (!isAuthenticated()) {
      nav(appLinks.login);
      return;
    }
  });

  return (
    <>
      <section className="app-layout bg-black">
        {/* <TopNav />  */}
        {/* <ActionButton onClick={ () => message.success( 'clicked!' ) } /> */}

        <a
          href="https://access.riviaclinics.com/provider"
          target="_blank"
          rel="noopener noreferrer"
          className="app-btn btn-secondary d-inline-flex align-items-center"
          title="Open the Rivia Access provider dashboard"
          style={{
            position: "fixed",
            top: "16px",
            right: "16px",
            zIndex: 1000,
          }}>
          <span className="bi bi-box-arrow-up-right me-2" />
          <span className="d-none d-md-inline-block">Open RampOS</span>
        </a>


        <div className="row px-md-2 px-0 content">
          <div className="col-md-2 col-0">
            <BrowserView>
              <DesktopNav />
            </BrowserView>
          </div>

          <div className="col-md-10 col-12">
            <div className="layout-outlet">
              {isAuthenticated() ? <Outlet /> : <p>authenticate</p>}
            </div>
          </div>
        </div>

        <MobileView>
          <MobileNav />
        </MobileView>
      </section>
    </>
  );
};

const ExternalLayout = (props) => {
  const nav = useNavigate();

  useEffect(() => {
    if (!extAuth.isAuthenticated()) {
      nav(appLinks.exterals.login);
      return;
    }
  });

  return (
    <div className="row portal">
      <div className="mx-auto col-md-10 col-12">
        <div className="text-center py-3">
          <img src={logo} alt="rivia logo" width={150} />
          {/* <kbd>{ constants.siteTitle }</kbd>
                    <Link to="#">Help</Link> */}
        </div>

        <div className="inner-layer">
          <div className="d-flex justify-content-between p-2">
            <h6>{`${extAuth.getUser()?.fullName} (${
              extAuth.getUser()?.externalName
            })`}</h6>
            <div>
              <button
                className="button"
                onClick={() => nav(appLinks.exterals.passwordReset)}>
                Reset Password
              </button>
              <button
                className="button is-danger is-light"
                onClick={() => extAuth.logOut()}>
                Logout
                <span className="bi bi-lock ms-2"></span>
              </button>
            </div>
          </div>
          <div className="content my-2">
            {extAuth.isAuthenticated() ? <Outlet /> : <p>authenticate</p>}
          </div>
        </div>
        <div className="row text-center">
          <CopyRightTag />
        </div>
      </div>
    </div>
  );
};

const CarePortalLayout = (props) => {
  return (
    <div className="row portal">
      <PageTitle title="Member Profile" />
      <div className="mx-auto col-md-10 col-12">
        {isMemberAuthed() && (
          <div className="p-3">
            <img src={logo} alt="rivia logo" width={150} />
          </div>
        )}
        <div className="my-2">
          {isMemberAuthed() ? <Outlet /> : <MemberLoginPage />}
        </div>
        {isMemberAuthed() && <CopyRightTag className="ps-3" />}
      </div>
    </div>
  );
};

export { AppLayout, ExternalLayout, CarePortalLayout };
